import { useState, useEffect } from 'react';
import axios from 'axios';
import ExcelDownload from '../../../component/common/button/ExcelDownload';
import NewDataGrid from '../../../component/common/dataGrid/NewDataGrid';

import { Search16w } from '../../../images/icons/icons_component';

function DutySearch_popup() {

    const [emog, setEmog] = useState([]);
    const [searchParams, setSearchParams] = useState({
        searchFromdate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchTodate: new Date((new Date()).getTime() + 1000 * 60 * 60 * 9).toISOString().split('T')[0],
        searchEmog: '',
    });
    const dataHead = ['기관명', '월', '소속과', '전담전문의', '당직일수', '평균 당직일수', '소속과별 당직일수']; //component화 
    const dataColumn = ['EMOGDESC', 'MONTH', 'CLNICKWA_NM', 'NM', 'DUTY_CNT', 'AVG_DUTY_CNT', 'DEPT_DUTY_CNT'];
    const apiCall = '/trmsapi/dutyschd/getDutyCntSearch.do';
    const apiCntCall = '';
    const excelFileName = '기관별_전담전문의 별 당직일수';
    const excelHead = [];
    const mergeConfig = [{ key: 'EMOGDESC', row: null }, { key: 'MONTH' }, { key: 'CLNICKWA_NM' }, { key: 'DEPT_DUTY_CNT' }];

    const propsInfo = {
        dataHead: dataHead,
        dataColumn: dataColumn,
        apiCall: apiCall,
        apiCntCall: apiCntCall,
        excelFileName: excelFileName,
        excelHead: excelHead
    }

    const [state, setState] = useState({
        dataList: [],
        isSearched: false,
        isLoading: false,
        loadingHeight: '6rem'
    })

    const [pageInfo, setPageInfo] = useState({
        paginationTF: false,
        currentPage: 1,
        itemsPerPage: 50, // 한 페이지당 보여줄 데이터 수
        totalItems: 0 // 전체 데이터 수
    });

    const fetchEmogList = async () => {
        try {
            const response = await axios.get('/ptmiapi/trmsEmogList.do', {
                params: {
                    grdc: 'Y',
                    loca: '',
                }
            });
            setEmog(response.data.emogList || []);
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    };

    const search = async () => {
        try {
            setState((prev) => ({
                ...prev,
                isLoading: true,
            }));
            const response = await axios.get(apiCall, {
                params: searchParams,
            });
            setState((prev) => ({
                ...prev,
                dataList: response.data,
                isSearched: true,
                isLoading: false,
            }));
            setPageInfo((prev) => ({
                ...prev,
                totalItems: response.data.length,
            }))
        } catch (error) {
            console.error('병원 목록 로딩 중 오류 발생:', error);
        }
    }

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        const newParams = {
            ...searchParams,
            [name]: value
        };
        setSearchParams(newParams);
    };

    useEffect(() => {
        fetchEmogList();
    }, []);

    return (
        <div className='popup_container bg_tr_bg'>
            <h5>기관별 당직일수 조회</h5>
            <div className='flex flex-col'>
                <div className="com-search tr_pop_th_bg" style={{ borderTop: 'var(--tr-primary-border' }}>
                    <table>
                        <colgroup>
                            <col width="10%" />
                            <col width="20%" />
                            <col width="10%" />
                            <col width="20%" />
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>등록년월</th>
                                <td>
                                    <input
                                        type="date"
                                        name="searchFromdate"
                                        value={searchParams.searchFromdate}
                                        onChange={handleInputChange}
                                    />
                                    &nbsp;~&nbsp;
                                    <input
                                        type="date"
                                        name="searchTodate"
                                        value={searchParams.searchTodate}
                                        onChange={handleInputChange}
                                        min={searchParams.searchFromdate}
                                    />
                                </td>
                                <th>의료기관명</th>
                                <td>
                                    <select
                                        name='searchEmog'
                                        className='w-full'
                                        value={searchParams.searchEmog}
                                        onChange={handleInputChange}
                                    >
                                        <option value="">전체</option>
                                        {emog.map(hosp => (
                                            <option key={hosp.emogcode} value={hosp.emogcode}>
                                                {hosp.emogdesc}
                                            </option>
                                        ))}
                                    </select>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div className='search_btn_wrapper'>
                    <span className='total_items'>전체&nbsp;<strong className='tr_primary'>{pageInfo.totalItems}</strong>건</span>
                    <div className='btn_container'>
                        <button onClick={search} className='search_btn bg_tr_primary'><Search16w />검색</button>
                        <ExcelDownload
                            excelHead={dataHead}
                            excelData={state.dataList}
                            searched={state.isSearched}
                            dataCode={dataColumn}
                            excelFileName={excelFileName}
                            mergeData={mergeConfig}
                        />
                    </div>
                </div>
                <div className='tr_pop'>
                    <NewDataGrid
                        propsInfo={propsInfo}
                        state={state}
                        pageInfo={pageInfo}
                        setPageInfo={setPageInfo}
                        mergeConfig={mergeConfig}
                        gridHeight='30rem'
                    />
                </div>
            </div>
        </div>
    );
}

export default DutySearch_popup;